/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsConfig = {
  aws_project_region: process.env.APPSYNC_REGION ?? 'us-east-1',
  aws_cognito_region: process.env.APPSYNC_REGION ?? 'us-east-1',
  aws_user_pools_id: process.env.NEXT_PUBLIC_AWS_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.NEXT_PUBLIC_AWS_USER_POOL_CLIENT_ID,
  oauth: {
    domain: 'prod.klic.gg',
    provider: [
      {
        name: 'discord',
        clientId: 'rTSPehfC1sUXIS2mrSqcTSXML7LuRtuB',
        issuer: 'https://betaklic.us.auth0.com',
        clientSecret:
          '2ycq5SeS5AcVRfVmaBplcFLmTyOqIDYTwYseaB28grK-Vi_LFRCRCdyDy3t--buG',
      },
    ],
    scope: ['profile', 'email', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn:
      process.env.NEXT_PUBLIC_SOCIAL_LOGIN_URL ||
      'http://localhost:3000/oauth2/idpresponse',
    redirectSignOut:
      process.env.NEXT_PUBLIC_SOCIAL_LOGOUT_URL ||
      'http://localhost:3000/oauth2/idpresponse',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['GOOGLE', 'OpenID', 'SAML'],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_verification_mechanisms: ['EMAIL'],
  API: {
    aws_appsync_region: 'us-east-1',
    aws_appsync_graphqlEndpoint:
      process.env.NEXT_PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT_V2,
    aws_appsync_apiKey: process.env.NEXT_PUBLIC_AWS_APPSYNC_APIKEY_V2,
    aws_appsync_authenticationType:
      process.env.NEXT_PUBLIC_AWS_APPSYNC_AUTHENTICATIONTYPE,
  },
};

export default awsConfig;
